/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConversationDetailDTO } from '../models';
// @ts-ignore
import type { ConversationResponseDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageConversationResponseDTO } from '../models';
// @ts-ignore
import type { PermissionRequestDTO } from '../models';
// @ts-ignore
import type { PermissionRequestDetailDTO } from '../models';
// @ts-ignore
import type { StartConversationRequestDTO } from '../models';
/**
 * AssistantApi - axios parameter creator
 * @export
 */
export const AssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary End Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endConversationApiV1AssistantConversationsConversationIdDelete: async (conversationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('endConversationApiV1AssistantConversationsConversationIdDelete', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary End Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endConversationApiV1AssistantConversationsConversationIdDelete_1: async (conversationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('endConversationApiV1AssistantConversationsConversationIdDelete_1', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Generate Conversation Title
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch: async (conversationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}/generate-title`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Generate Conversation Title
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2: async (conversationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}/generate-title`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationApiV1AssistantConversationsConversationIdGet: async (conversationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationApiV1AssistantConversationsConversationIdGet', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationApiV1AssistantConversationsConversationIdGet_3: async (conversationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationApiV1AssistantConversationsConversationIdGet_3', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
         * @summary Get Permission Request
         * @param {string} permissionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet: async (permissionId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet', 'permissionId', permissionId)
            const localVarPath = `/api/v1/assistant/conversations/permissions/{permission_id}`
                .replace(`{${"permission_id"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
         * @summary Get Permission Request
         * @param {string} permissionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4: async (permissionId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4', 'permissionId', permissionId)
            const localVarPath = `/api/v1/assistant/conversations/permissions/{permission_id}`
                .replace(`{${"permission_id"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Permission Requests
         * @param {string} conversationId 
         * @param {string | null} [status] Filter by status
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet: async (conversationId: string, status?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}/permissions`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Permission Requests
         * @param {string} conversationId 
         * @param {string | null} [status] Filter by status
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5: async (conversationId: string, status?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5', 'conversationId', conversationId)
            const localVarPath = `/api/v1/assistant/conversations/{conversation_id}/permissions`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
         * @summary List Conversations
         * @param {boolean} [includeEnded] Include ended conversations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationsApiV1AssistantConversationsGet: async (includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeEnded !== undefined) {
                localVarQueryParameter['include_ended'] = includeEnded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
         * @summary List Conversations
         * @param {boolean} [includeEnded] Include ended conversations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationsApiV1AssistantConversationsGet_6: async (includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeEnded !== undefined) {
                localVarQueryParameter['include_ended'] = includeEnded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
         * @summary Search Conversations
         * @param {string} q Search query (min 2 characters)
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsApiV1AssistantConversationsSearchGet: async (q: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchConversationsApiV1AssistantConversationsSearchGet', 'q', q)
            const localVarPath = `/api/v1/assistant/conversations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
         * @summary Search Conversations
         * @param {string} q Search query (min 2 characters)
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsApiV1AssistantConversationsSearchGet_7: async (q: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchConversationsApiV1AssistantConversationsSearchGet_7', 'q', q)
            const localVarPath = `/api/v1/assistant/conversations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
         * @summary Start Conversation
         * @param {StartConversationRequestDTO} startConversationRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startConversationApiV1AssistantConversationsPost: async (startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startConversationRequestDTO' is not null or undefined
            assertParamExists('startConversationApiV1AssistantConversationsPost', 'startConversationRequestDTO', startConversationRequestDTO)
            const localVarPath = `/api/v1/assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startConversationRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
         * @summary Start Conversation
         * @param {StartConversationRequestDTO} startConversationRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startConversationApiV1AssistantConversationsPost_8: async (startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startConversationRequestDTO' is not null or undefined
            assertParamExists('startConversationApiV1AssistantConversationsPost_8', 'startConversationRequestDTO', startConversationRequestDTO)
            const localVarPath = `/api/v1/assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startConversationRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssistantApi - functional programming interface
 * @export
 */
export const AssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary End Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endConversationApiV1AssistantConversationsConversationIdDelete(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endConversationApiV1AssistantConversationsConversationIdDelete(conversationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.endConversationApiV1AssistantConversationsConversationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary End Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endConversationApiV1AssistantConversationsConversationIdDelete_1(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endConversationApiV1AssistantConversationsConversationIdDelete_1(conversationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.endConversationApiV1AssistantConversationsConversationIdDelete_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Generate Conversation Title
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch(conversationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Generate Conversation Title
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2(conversationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationApiV1AssistantConversationsConversationIdGet(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationApiV1AssistantConversationsConversationIdGet(conversationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getConversationApiV1AssistantConversationsConversationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationApiV1AssistantConversationsConversationIdGet_3(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationApiV1AssistantConversationsConversationIdGet_3(conversationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getConversationApiV1AssistantConversationsConversationIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
         * @summary Get Permission Request
         * @param {string} permissionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet(permissionId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionRequestDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet(permissionId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
         * @summary Get Permission Request
         * @param {string} permissionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4(permissionId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionRequestDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4(permissionId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Permission Requests
         * @param {string} conversationId 
         * @param {string | null} [status] Filter by status
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet(conversationId: string, status?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionRequestDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet(conversationId, status, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Permission Requests
         * @param {string} conversationId 
         * @param {string | null} [status] Filter by status
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5(conversationId: string, status?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionRequestDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5(conversationId, status, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
         * @summary List Conversations
         * @param {boolean} [includeEnded] Include ended conversations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConversationsApiV1AssistantConversationsGet(includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConversationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConversationsApiV1AssistantConversationsGet(includeEnded, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.listConversationsApiV1AssistantConversationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
         * @summary List Conversations
         * @param {boolean} [includeEnded] Include ended conversations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConversationsApiV1AssistantConversationsGet_6(includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConversationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConversationsApiV1AssistantConversationsGet_6(includeEnded, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.listConversationsApiV1AssistantConversationsGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
         * @summary Search Conversations
         * @param {string} q Search query (min 2 characters)
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConversationsApiV1AssistantConversationsSearchGet(q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConversationsApiV1AssistantConversationsSearchGet(q, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.searchConversationsApiV1AssistantConversationsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
         * @summary Search Conversations
         * @param {string} q Search query (min 2 characters)
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConversationsApiV1AssistantConversationsSearchGet_7(q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConversationsApiV1AssistantConversationsSearchGet_7(q, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.searchConversationsApiV1AssistantConversationsSearchGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
         * @summary Start Conversation
         * @param {StartConversationRequestDTO} startConversationRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startConversationApiV1AssistantConversationsPost(startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startConversationApiV1AssistantConversationsPost(startConversationRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.startConversationApiV1AssistantConversationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
         * @summary Start Conversation
         * @param {StartConversationRequestDTO} startConversationRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startConversationApiV1AssistantConversationsPost_8(startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startConversationApiV1AssistantConversationsPost_8(startConversationRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.startConversationApiV1AssistantConversationsPost_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssistantApi - factory interface
 * @export
 */
export const AssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssistantApiFp(configuration)
    return {
        /**
         * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary End Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endConversationApiV1AssistantConversationsConversationIdDelete(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.endConversationApiV1AssistantConversationsConversationIdDelete(conversationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary End Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endConversationApiV1AssistantConversationsConversationIdDelete_1(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.endConversationApiV1AssistantConversationsConversationIdDelete_1(conversationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Generate Conversation Title
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponseDTO> {
            return localVarFp.generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch(conversationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Generate Conversation Title
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponseDTO> {
            return localVarFp.generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2(conversationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationApiV1AssistantConversationsConversationIdGet(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDetailDTO> {
            return localVarFp.getConversationApiV1AssistantConversationsConversationIdGet(conversationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Conversation
         * @param {string} conversationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationApiV1AssistantConversationsConversationIdGet_3(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDetailDTO> {
            return localVarFp.getConversationApiV1AssistantConversationsConversationIdGet_3(conversationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
         * @summary Get Permission Request
         * @param {string} permissionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet(permissionId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PermissionRequestDetailDTO> {
            return localVarFp.getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet(permissionId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
         * @summary Get Permission Request
         * @param {string} permissionId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4(permissionId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PermissionRequestDetailDTO> {
            return localVarFp.getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4(permissionId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Permission Requests
         * @param {string} conversationId 
         * @param {string | null} [status] Filter by status
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet(conversationId: string, status?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionRequestDTO>> {
            return localVarFp.getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet(conversationId, status, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
         * @summary Get Permission Requests
         * @param {string} conversationId 
         * @param {string | null} [status] Filter by status
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5(conversationId: string, status?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionRequestDTO>> {
            return localVarFp.getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5(conversationId, status, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
         * @summary List Conversations
         * @param {boolean} [includeEnded] Include ended conversations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationsApiV1AssistantConversationsGet(includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConversationResponseDTO> {
            return localVarFp.listConversationsApiV1AssistantConversationsGet(includeEnded, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
         * @summary List Conversations
         * @param {boolean} [includeEnded] Include ended conversations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationsApiV1AssistantConversationsGet_6(includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConversationResponseDTO> {
            return localVarFp.listConversationsApiV1AssistantConversationsGet_6(includeEnded, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
         * @summary Search Conversations
         * @param {string} q Search query (min 2 characters)
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsApiV1AssistantConversationsSearchGet(q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationResponseDTO>> {
            return localVarFp.searchConversationsApiV1AssistantConversationsSearchGet(q, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
         * @summary Search Conversations
         * @param {string} q Search query (min 2 characters)
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConversationsApiV1AssistantConversationsSearchGet_7(q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationResponseDTO>> {
            return localVarFp.searchConversationsApiV1AssistantConversationsSearchGet_7(q, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
         * @summary Start Conversation
         * @param {StartConversationRequestDTO} startConversationRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startConversationApiV1AssistantConversationsPost(startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponseDTO> {
            return localVarFp.startConversationApiV1AssistantConversationsPost(startConversationRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
         * @summary Start Conversation
         * @param {StartConversationRequestDTO} startConversationRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startConversationApiV1AssistantConversationsPost_8(startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponseDTO> {
            return localVarFp.startConversationApiV1AssistantConversationsPost_8(startConversationRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssistantApi - object-oriented interface
 * @export
 * @class AssistantApi
 * @extends {BaseAPI}
 */
export class AssistantApi extends BaseAPI {
    /**
     * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary End Conversation
     * @param {string} conversationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public endConversationApiV1AssistantConversationsConversationIdDelete(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).endConversationApiV1AssistantConversationsConversationIdDelete(conversationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * End a conversation by setting ended_at timestamp.  This is a soft delete - the conversation and messages remain in the database.  Args:     conversation_id: ID of the conversation to end     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     None (204 No Content)  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary End Conversation
     * @param {string} conversationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public endConversationApiV1AssistantConversationsConversationIdDelete_1(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).endConversationApiV1AssistantConversationsConversationIdDelete_1(conversationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary Generate Conversation Title
     * @param {string} conversationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch(conversationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate or regenerate a title and summary for a conversation.  Triggers an LLM call to generate a title and summary based on the conversation\'s message history.  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Updated conversation with title and summary  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary Generate Conversation Title
     * @param {string} conversationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).generateConversationTitleApiV1AssistantConversationsConversationIdGenerateTitlePatch_2(conversationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary Get Conversation
     * @param {string} conversationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public getConversationApiV1AssistantConversationsConversationIdGet(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).getConversationApiV1AssistantConversationsConversationIdGet(conversationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a conversation with full message history.  Messages are ordered by message_number for deterministic ordering.  Args:     conversation_id: ID of the conversation to retrieve     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Conversation detail with all messages  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary Get Conversation
     * @param {string} conversationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public getConversationApiV1AssistantConversationsConversationIdGet_3(conversationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).getConversationApiV1AssistantConversationsConversationIdGet_3(conversationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
     * @summary Get Permission Request
     * @param {string} permissionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet(permissionId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet(permissionId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed permission request with diff.  Returns the full permission request including: - Current state (from execution_result if available) - Proposed changes - Unified diff showing changes  Args:     permission_id: ID of the permission request     current_user: Currently authenticated user     permission_manager: Permission manager dependency  Returns:     Permission request with current state and diff  Raises:     HTTPException: If permission request not found or access denied (404)
     * @summary Get Permission Request
     * @param {string} permissionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4(permissionId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).getPermissionRequestApiV1AssistantConversationsPermissionsPermissionIdGet_4(permissionId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary Get Permission Requests
     * @param {string} conversationId 
     * @param {string | null} [status] Filter by status
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet(conversationId: string, status?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet(conversationId, status, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get permission requests for a conversation with optional status filter.  Permission requests are ordered by created_at DESC (newest first). Automatically filtered by organization (multi-tenant security).  Args:     conversation_id: ID of the conversation     current_user: Currently authenticated user     permission_manager: Permission manager dependency     status: Optional status filter (pending, approved, rejected, executed, failed)  Returns:     List of permission requests for the conversation  Raises:     HTTPException: If conversation not found or access denied (404)
     * @summary Get Permission Requests
     * @param {string} conversationId 
     * @param {string | null} [status] Filter by status
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5(conversationId: string, status?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).getPermissionRequestsApiV1AssistantConversationsConversationIdPermissionsGet_5(conversationId, status, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
     * @summary List Conversations
     * @param {boolean} [includeEnded] Include ended conversations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public listConversationsApiV1AssistantConversationsGet(includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).listConversationsApiV1AssistantConversationsGet(includeEnded, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List conversations for the current user with pagination.  Conversations are ordered by started_at DESC (newest first). By default, only active conversations are returned.  Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     params: Pagination parameters (limit 1-1000, default 100; offset)     include_ended: Whether to include ended conversations (default False)  Returns:     Page of conversations with message counts  Raises:     HTTPException: If parameters are invalid
     * @summary List Conversations
     * @param {boolean} [includeEnded] Include ended conversations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public listConversationsApiV1AssistantConversationsGet_6(includeEnded?: boolean, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).listConversationsApiV1AssistantConversationsGet_6(includeEnded, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
     * @summary Search Conversations
     * @param {string} q Search query (min 2 characters)
     * @param {number} [limit] Maximum number of results
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public searchConversationsApiV1AssistantConversationsSearchGet(q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).searchConversationsApiV1AssistantConversationsSearchGet(q, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search conversations by message content.  Searches for conversations containing messages that match the query string. Uses PostgreSQL ILIKE for case-insensitive partial matching. Optimized query uses subquery to get message counts in single query (no N+1).  Args:     current_user: Currently authenticated user     chat_service: Assistant chat service dependency     q: Search query (minimum 2 characters)     limit: Maximum number of results (1-50, default 20)  Returns:     List of conversations containing matching messages  Raises:     HTTPException: If query is too short or limit is invalid
     * @summary Search Conversations
     * @param {string} q Search query (min 2 characters)
     * @param {number} [limit] Maximum number of results
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public searchConversationsApiV1AssistantConversationsSearchGet_7(q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).searchConversationsApiV1AssistantConversationsSearchGet_7(q, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
     * @summary Start Conversation
     * @param {StartConversationRequestDTO} startConversationRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public startConversationApiV1AssistantConversationsPost(startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).startConversationApiV1AssistantConversationsPost(startConversationRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a new assistant conversation.  Args:     request: Conversation creation request with optional agent_id and initial_message     current_user: Currently authenticated user     chat_service: Assistant chat service dependency  Returns:     Created conversation with metadata  Raises:     HTTPException: If conversation creation fails
     * @summary Start Conversation
     * @param {StartConversationRequestDTO} startConversationRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public startConversationApiV1AssistantConversationsPost_8(startConversationRequestDTO: StartConversationRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).startConversationApiV1AssistantConversationsPost_8(startConversationRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

